import { useQuery } from '@tanstack/react-query';

import { getRoomAvailability } from 'src/api/roomService/requests';

interface UseRoomAvailabilityParams {
    developmentSlug: string | null;
    academicYear: string | null;
    moveInDate: string | null;
    duration: number | null;
    enabled: boolean;
}

export const useRoomAvailability = ({
    developmentSlug,
    academicYear,
    moveInDate,
    duration,
    enabled,
}: UseRoomAvailabilityParams) =>
    useQuery({
        queryKey: ['room-availability', developmentSlug, academicYear, moveInDate, duration],
        queryFn: () =>
            getRoomAvailability({
                developmentSlug: developmentSlug!,
                academicYear: academicYear!,
                moveInDate: moveInDate!,
                duration: duration!,
            }),
        enabled,
    });
